import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { SeoService } from '../../../core/services/seo.service';

/**
 * /hilfe — Rollenwahl-Seite.
 *
 * Eingeloggte Nutzer bekommen einen Hinweis-Banner mit Direkt-Link zur
 * passenden Hilfe-Seite, sehen aber trotzdem die Wahl (OnePager § 14.2:
 * Endkunden sollen auch Handwerker-FAQs entdecken können). Anonyme Nutzer
 * sehen nur die zwei Karten.
 */
@Component({
  selector: 'app-hilfe-rollenwahl',
  standalone: true,
  imports: [CommonModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './hilfe-rollenwahl.component.html',
  styleUrl: './hilfe-rollenwahl.component.scss',
})
export class HilfeRollenwahlComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly seo = inject(SeoService);

  readonly user$ = this.auth.currentUser$;

  ngOnInit(): void {
    this.seo.apply({
      title: 'Hilfe & Support',
      description:
        'Antworten zu Anfragen, Buchungen, Zahlungen und mehr. Such dir aus, ob du Hilfe als Kunde oder als Handwerker suchst.',
      path: '/hilfe',
    });
  }

  /** Liefert die für die Rolle passende Hilfe-Route oder null bei Admin/Anon. */
  preferredRoute(role: string | null | undefined): string | null {
    switch (role) {
      case 'Endkunde':
        return '/hilfe/kunden';
      case 'Handwerker':
        return '/hilfe/handwerker';
      default:
        return null;
    }
  }
}
